(function () {
    'use strict';

    angular.module('app.eventDisplay', [
        'app.core',
        'app.widgets'
    ]);
})();
